import axios from 'axios';

export default ({ requiresAuth = false } = {}) => {
    const options = {};
   options.baseURL = 'https://api-jobtrade.theonesystem.ch/api';
    options.headers = {
        "Content-type": "application/json",
        "Accept": "application/json",
        // 'Authorization': `Bearer ${localStorage.token}`
    };

    if (requiresAuth) {
        options.headers.Authorization = `Bearer ${localStorage.token}`
    }
    const instance = axios.create(options);

    instance.interceptors.response.use(response => {
        return response;
    }, error => {
        return Promise.reject(error);
    });
    return instance;
};
